import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@trackman/web-shared-components';

import { FC } from 'react';

interface STProps {
  columns: any[];
  data: any[];
  page?: number;
  count?: number;
  rowsPerPage?: number;
  onChangePage: (page: number) => void;
  rowMapper?: (cells: any[]) => JSX.Element;
  renderCell: (props: any) => JSX.Element;
  onHeaderClick?: (columnKey: string, defaultClick?: () => void) => void;
  sortedColumn?: string;
  isLoading?: boolean;
}

export const SimpleTable: FC<STProps> = (props) => {
  const {
    rowMapper,
    renderCell,
    columns,
    data,
    page = 1,
    rowsPerPage = 10,
    onChangePage,
    onHeaderClick,
    sortedColumn,
    isLoading = false,
  } = props;

  return (
    <TableContainer
      data-testid='TableContainer01'
      sx={{
        maxWidth: 1200,
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id}>
                {onHeaderClick ? (
                  <TableSortLabel
                    active={sortedColumn === column.id}
                    direction='asc'
                    onClick={() => {
                      if (onHeaderClick) {
                        onHeaderClick(column.id);
                      }
                    }}
                  >
                    {column.Header}
                  </TableSortLabel>
                ) : (
                  column.Header
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow key={index} hover>
                {columns.map((column) => (
                  <TableCell key={column.id}>
                    {renderCell({
                      cellValue: row[column.id],
                      columnHeader: column.Header,
                      columnId: column.id,
                      row,
                    })}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
